/**
 * Easify Product Options wording fix.
 * Easify's price-summary widget shows "Your selections will add an
 * additional charge of $X.XX" split across two sibling spans:
 *   <div class="po-priceSummary-root">
 *     <span class="po-priceSummary-summaryText">...add an additional charge of</span>
 *     <span class="po-priceSummary-price"><span> $X.XX</span></span>
 *   </div>
 * This reads like a flat one-time fee, but the charge actually applies
 * per unit (confirmed against cart totals: 5 engraved units = 5x $5, not
 * a flat $5). This appends " per item" inside the price span so wholesale
 * buyers ordering multiple units understand the charge scales with
 * quantity. Runs via MutationObserver since Easify renders inside a
 * dynamically-injected widget with no stable server-side hooks.
 */
(function () {
  var SUFFIX = ' per item';
  var MARKER = 'data-easify-wording-fixed';

  function fixPriceSummary(root) {
    if (!root || !root.querySelectorAll) return;
    var priceEls = root.querySelectorAll('[class*="po-priceSummary-price"]');
    for (var i = 0; i < priceEls.length; i++) {
      var el = priceEls[i];
      if (el.getAttribute(MARKER)) continue;
      if (el.textContent.indexOf(SUFFIX.trim()) !== -1) continue;
      el.appendChild(document.createTextNode(SUFFIX));
      el.setAttribute(MARKER, 'true');
    }
    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches('[class*="po-priceSummary-price"]') &&
      !root.getAttribute(MARKER) &&
      root.textContent.indexOf(SUFFIX.trim()) === -1
    ) {
      root.appendChild(document.createTextNode(SUFFIX));
      root.setAttribute(MARKER, 'true');
    }
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        if (m.addedNodes[j].nodeType === 1) fixPriceSummary(m.addedNodes[j]);
      }
      if (m.type === 'characterData' && m.target && m.target.parentElement) {
        var container = m.target.parentElement.closest
          ? m.target.parentElement.closest('[class*="po-priceSummary-root"]')
          : null;
        if (container) fixPriceSummary(container);
      }
    }
  });

  function start() {
    fixPriceSummary(document.body);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
